import { ICreateCustomerState } from './createCustomerContext';
import { CreateCustomerActionTypes, TCreateCustomerAction } from './createCustomerActions';

export const createCustomerReducer = (
	state: ICreateCustomerState,
	action: TCreateCustomerAction,
): ICreateCustomerState => {
	switch (action.type) {
		case CreateCustomerActionTypes.SET_FILE:
			return {
				...state,
				fileId: action.payload.fileId,
				sourceUrlLocally: action.payload.sourceUrlLocally,
			};
		case CreateCustomerActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateCustomerActionTypes.CHANGE_EMAIL:
			return {
				...state,
				email: action.payload.email,
			};
		case CreateCustomerActionTypes.CHANGE_EMAIL_BODY_TEMPLATE:
			return {
				...state,
				emailBodyTemplate: action.payload.emailBodyTemplate,
			};
		case CreateCustomerActionTypes.SET_CLIENT_TYPE:
			return {
				...state,
				clientType: action.payload.clientType,
			};
		case CreateCustomerActionTypes.CHANGE_BILL_TEMPLATE_FILE_DATA:
			return {
				...state,
				billTemplateFileData: action.payload.billTemplateFileData,
			};
		case CreateCustomerActionTypes.CHANGE_BILL_ADVERTISING_IMAGE_DATA:
			return {
				...state,
				billAdvertisingImageData: action.payload.billAdvertisingImageData,
			};
		case CreateCustomerActionTypes.CHANGE_BILL_ADVERTISING_LINK:
			return {
				...state,
				billAdvertisingLink: action.payload.billAdvertisingLink,
			};
		case CreateCustomerActionTypes.CHANGE_PRICE_TYPE:
			return {
				...state,
				priceType: action.payload.priceType,
			};
		case CreateCustomerActionTypes.SET_TIPS_0:
			return {
				...state,
				tips0: action.payload.tips0,
			};
		case CreateCustomerActionTypes.SET_TIPS_1:
			return {
				...state,
				tips1: action.payload.tips1,
			};
		case CreateCustomerActionTypes.SET_TIPS_2:
			return {
				...state,
				tips2: action.payload.tips2,
			};
		case CreateCustomerActionTypes.SET_TIPS_3:
			return {
				...state,
				tips3: action.payload.tips3,
			};
		case CreateCustomerActionTypes.SET_DEFAULT_TIPS:
			return {
				...state,
				defaultTips: action.payload.defaultTips,
			};
		case CreateCustomerActionTypes.SET_ADS:
			return {
				...state,
				ads: action.payload.ads,
			};
		case CreateCustomerActionTypes.SET_MIXPANEL_TOKEN:
			return {
				...state,
				mixpanelToken: action.payload.mixpanelToken,
			};
		case CreateCustomerActionTypes.SET_STOP_LIST_SYNC_INTERVAL_MINUTES:
			return {
				...state,
				stopListSyncIntervalMinutes: action.payload.stopListSyncIntervalMinutes,
			};
		case CreateCustomerActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.fetchedLanguages,
			};
		case CreateCustomerActionTypes.SET_ID_CUSTOMER_DEFAULT_LANGUAGE:
			return {
				...state,
				IDSelectedCustomerDefaultLanguage: action.payload.IDSelectedCustomerDefaultLanguage,
			};
		case CreateCustomerActionTypes.SET_IDs_CUSTOMER_LANGUAGES:
			return {
				...state,
				IDsSelectedCustomerLanguages: action.payload.IDsSelectedCustomerLanguages,
			};
		case CreateCustomerActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateCustomerActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateCustomerActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				sourceUrlLocally: null,
				name: '',
				email: '',
				emailBodyTemplate: '',
				clientType: null,
				billTemplateFileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				billAdvertisingImageData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				billAdvertisingLink: null,
				priceType: null,
				tips0: null,
				tips1: null,
				tips2: null,
				tips3: null,
				defaultTips: null,
				ads: '',
				mixpanelToken: '',
				stopListSyncIntervalMinutes: 5,
				fetchedLanguages: [],
				IDSelectedCustomerDefaultLanguage: null,
				IDsSelectedCustomerLanguages: [],
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
